export default {
  'me.title': 'Member Information',
  'me.line_id': 'LINE ID',
  'me.member_card_number': 'Member Card Number',
  'me.education_background': 'Education Background',
  'me.habit': 'Interests and Hobbies',
  'me.register_full': 'Register as a Full Member',
  'me.modify': 'Edit Member Information',
} as Record<string, string>;
